import type { BillboardDetailData } from '@/features/billboards/api/billboardApi';
import { ExpandableCopy } from '@/features/billboards/components/detail/ExpandableCopy';
import { InfoRow } from '@/features/billboards/components/detail/InfoRow';
import { SectionTitle } from '@/features/billboards/components/detail/SectionTitle';
import { formatFieldLabel, formatScreenName } from '@/features/billboards/utils/billboardDetailUtils';

type ScreenInfoSectionProps = {
  billboard: BillboardDetailData;
};

/* Modified by: Ishan | Soft-contrast screen information card */
export function ScreenInfoSection({ billboard }: ScreenInfoSectionProps) {
  return (
    <section className="bg-white rounded-[24px] p-[22px] shadow-[0_10px_30px_rgba(60,40,120,0.05)] border border-[#EEEBF8]">
      <SectionTitle
        title="Screen information"
        subtitle="Core details for this display"
      />
      <dl>
        <InfoRow label="Screen ID" value={billboard.screenId || '—'} />
        <InfoRow
          label="Name"
          value={formatScreenName(billboard.screenName, '—')}
        />
        <InfoRow
          label="Orientation"
          value={formatFieldLabel(billboard.screenOrientation) || 'Portrait'}
        />
        <InfoRow
          label="Time slot"
          value={billboard.timeSlotType || '24 Hours'}
        />
        <InfoRow label="Device" value={billboard.deviceId?.deviceName || '—'} />
      </dl>
      <div className="mt-4 border-t border-[#F3F1FA] pt-4">
        <div className="text-[14px] font-extrabold text-[#3A3660] mt-1 mb-1.5">
          About
        </div>
        <ExpandableCopy
          text={billboard.aboutScreen}
          fallback="Details about reach, visibility, and audience for this screen will appear here."
        />
      </div>
    </section>
  );
}
